export const signerColors = [
  { bg: 'rgba(33, 150, 243, 0.2)', text: '#1565C0' }, // Blue
  { bg: 'rgba(255, 87, 34, 0.2)', text: '#D84315' }, // Orange
  { bg: 'rgba(76, 175, 80, 0.2)', text: '#2E7D32' }, // Green
  { bg: 'rgba(156, 39, 176, 0.2)', text: '#7B1FA2' }, // Purple
  { bg: 'rgba(255, 193, 7, 0.2)', text: '#FF8F00' }, // Amber
  { bg: 'rgba(233, 30, 99, 0.2)', text: '#C2185B' }, // Pink
  { bg: 'rgba(0, 150, 136, 0.2)', text: '#00695C' }, // Teal
  { bg: 'rgba(244, 67, 54, 0.2)', text: '#B71C1C' }, // Red
  { bg: 'rgba(121, 85, 72, 0.2)', text: '#4E342E' }, // Brown
  { bg: 'rgba(103, 58, 183, 0.2)', text: '#4527A0' }, // Deep Purple
];

export const getColor = signerIndex => signerColors[signerIndex % signerColors.length];
